export const ENTITY_CONFIG = {
  FAQ: {
    PRODUCT: {
      name: 'PRODUCT',
      label: 'Product',
      plural: 'Products',
      selectionType: 'single',
      endpoint: '/faq/entities/products',
      description: 'Select a product for FAQ assignment',
    },
    CATEGORY: {
      name: 'CATEGORY',
      label: 'Category',
      plural: 'Categories',
      selectionType: 'multiple',
      endpoint: '/faq/entities/categories',
      description: 'Select one or more categories',
    },
    VALUEPACK: {
      name: 'VALUEPACK',
      label: 'Value Pack',
      plural: 'Value Packs',
      selectionType: 'multiple',
      endpoint: '/faq/entities/valuepacks',
      description: 'Select one or more value packs',
    },
    PLAN: {
      name: 'PLAN',
      label: 'Question & Answer',
      plural: 'Questions & Answers',
      selectionType: 'single',
      endpoint: '/faq/entities/plans',
      description: 'Select a Q&A mapping',
    },
  },

  TESTIMONIAL: {
    PRODUCT: {
      name: 'PRODUCT',
      label: 'Product',
      plural: 'Products',
      selectionType: 'single',
      endpoint: '/faq/entities/products',
      description: 'Select a product for testimonial assignment',
    },
    CATEGORY: {
      name: 'CATEGORY',
      label: 'Category',
      plural: 'Categories',
      selectionType: 'multiple',
      endpoint: '/faq/entities/categories',
      description: 'Select one or more categories',
    },
    VALUEPACK: {
      name: 'VALUEPACK',
      label: 'Value Pack',
      plural: 'Value Packs',
      selectionType: 'multiple',
      endpoint: '/faq/entities/valuepacks',
      description: 'Select one or more value packs',
    },
  },

  SUBSCRIPTION: {
    PRODUCT: {
      // Changed from PACKAGE to PRODUCT
      name: 'PRODUCT',
      label: 'Product',
      plural: 'Products',
      selectionType: 'multiple',
      endpoint: '/faq/entities/products',
      description: 'Select products for custom pricing configuration',
    },
    PLAN: {
      name: 'PLAN',
      label: 'Plan',
      plural: 'plans',
      selectionType: 'single',
      endpoint: '/faq/entities/plans',
      description: 'Select a subscription plan',
    },
    VALUEPACK: {
      name: 'VALUEPACK',
      label: 'Value Pack',
      plural: 'Value Packs',
      selectionType: 'multiple',
      endpoint: '/faq/entities/valuepacks',
      description: 'Select value packs for subscription pricing',
    },
  },

  UNDERSTAND_IT_BETTER: {
    PRODUCT: {
      name: 'PRODUCT',
      label: 'Product',
      plural: 'Products',
      selectionType: 'single',
      endpoint: '/faq/entities/products',
      description: 'Select a product for Understand It Better section',
    },
    VALUEPACK: {
      name: 'VALUEPACK',
      label: 'Value Pack',
      plural: 'Value Packs',
      selectionType: 'single',
      endpoint: '/faq/entities/valuepacks',
      description: 'Select a value pack for Understand It Better section',
    },
    QUESTION_ANSWER: {
      name: 'QUESTION_ANSWER',
      label: 'Question & Answer',
      plural: 'Questions & Answers',
      selectionType: 'single',
      endpoint: '/faq/entities/plans',
      description: 'Select a Q&A for Understand It Better section',
    },
  },
};

// Helper function to get entity config safely
export const getEntityConfig = (context, entityType) => {
  const config = ENTITY_CONFIG[context];
  if (!config) return null;

  // Try exact match
  if (config[entityType]) return config[entityType];

  // Try case-insensitive match
  const upperKey = Object.keys(config).find(
    key => key.toUpperCase() === entityType.toUpperCase(),
  );

  if (upperKey) return config[upperKey];

  // Try matching by name property
  const byName = Object.values(config).find(
    item => item.name?.toUpperCase() === entityType.toUpperCase(),
  );

  return byName || null;
};
